// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3N9dl","alert":"SettungsInbox_alert__3AcV2"};